import { WebsiteContentMessage } from '../../../../../../types';
import { DomainRule } from '../../types';
import { CampaignScheduling } from '../../../../../../types/scheduling';

export const SegmentDateNotInBounds = 'segmentDateNotInBounds';

export const isSameDate = (date1: Date, date2: Date): boolean => {
  if (!date1 || !date2) {
    return false;
  }

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

/**
 * If segments are given schedules, their start and end dates must be within the boundaries
 * of the campaign level schedule
 * @param campaignScheduling
 * @param onsiteMessages
 * @returns boolean
 */
export const SegmentDatesAreWithinCampaignDates = (
  campaignScheduling: CampaignScheduling,
  onsiteMessages: Array<WebsiteContentMessage>,
): DomainRule => {
  if (Object.keys(campaignScheduling).length === 0) {
    return {
      result: 'pass',
      ruleKey: undefined,
    };
  }

  const results = onsiteMessages.map(message => {
    const scheduling = message?.scheduling;
    if (!scheduling) {
      return true;
    }

    if (campaignScheduling.startDate) {
      if (scheduling.startDate) {
        if (scheduling.startDate < campaignScheduling.startDate) {
          return false;
        }
      }

      if (campaignScheduling.startTime) {
        if (scheduling.startTime) {
          if (
            scheduling.startTime < campaignScheduling.startTime &&
            isSameDate(scheduling.startDate, campaignScheduling.startDate)
          ) {
            return false;
          }
        }
      }
    }

    if (campaignScheduling.endDate) {
      if (scheduling.endDate) {
        if (scheduling.endDate > campaignScheduling.endDate) {
          return false;
        }
      }

      if (campaignScheduling.endTime) {
        if (scheduling.endTime) {
          if (
            scheduling.endTime > campaignScheduling.endTime &&
            isSameDate(scheduling.endDate, campaignScheduling.endDate)
          ) {
            return false;
          }
        }
      }
    }

    return true;
  });

  if (results.flat().some(c => c === false)) {
    return {
      result: 'fail',
      ruleKey: SegmentDateNotInBounds,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
